import { render, staticRenderFns } from "./activeManager.vue?vue&type=template&id=a97ed872&scoped=true"
import script from "./activeManager.vue?vue&type=script&lang=js"
export * from "./activeManager.vue?vue&type=script&lang=js"
import style0 from "./activeManager.vue?vue&type=style&index=0&id=a97ed872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97ed872",
  null
  
)

export default component.exports